import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Fade from "@mui/material/Fade";
import { FAQS } from "../constants/Constant";

export default function FAQ() {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="w-full flex flex-col px-4 md:px-10 pt-[100px] pb-6 md:py-10 gap-[20px] min-h-full overflow-y-auto">
      <span className="text-[#101828] text-center font-Poppins text-[26px] md:text-[36px] not-italic font-[600] leading-[32px] md:leading-[44px] tracking-[-0.72px]">
        Frequently asked questions
      </span>
      <div>
        {FAQS.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleExpansion(`panel${index}`)}
            TransitionComponent={Fade} // Pass Fade directly without spreading props
            TransitionProps={{ timeout: 300 }} // Pass timeout through TransitionProps
            sx={{
              "& .MuiAccordionDetails-root": {
                display: expanded === `panel${index}` ? "block" : "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{
                textAlign: "left",
              }}
            >
              <span className="text-[16px] md:text-[18px]  font-Poppins text-[#101828] not-italic font-[500] leading-[28px] ">
                {faq.question}
              </span>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                textAlign: "left",
              }}
            >
              <span className="text-[14px] md:text-[16px]  font-Poppins  text-[#667085] not-italic font-[400] leading-[24px] ">
                {faq.answer}
              </span>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
}
